export default {
	craftsmanTasks: {
		create: 'Handwerkerauftrag erstellen',
		subject_type: 'Art',
		craftsman: 'Handwerker',
		craftsmanTaskType: 'Handwerkerauftrag Art',
		scheduling: 'Terminierung',
		process: 'Vorgang',
		building: {
			name: '@:entity.building.name',
		},
		unit: {
			name: '@:entity.unit.name',
		},
		team: {
			last_name: '@:entity.team.name',
		},
		assignedOn: 'Beauftragt am',
		completed: 'Erledigt',
		estimated_price: 'Schätzbetrag',
		status_text: 'Informationen zum aktuellen Status',
		contact_persons: 'Kontaktpersonen',
		isUpdated: 'wurde aktualisiert',
		total_amount: '@:component.invoice.total_amount',
	},
}
